import React from 'react';

import AccountCreationLoadingAnimation from '../../loading-animation';

import { IGetOptInModalLoadingPropsParams, IGetOptInModalLoadingPropsReturnValue } from './types';

function getOptInModalLoadingProps({
  title,
  description,
}: IGetOptInModalLoadingPropsParams): IGetOptInModalLoadingPropsReturnValue {
  return {
    heading: title,
    image: <AccountCreationLoadingAnimation />,
    body: description,
  };
}

export default getOptInModalLoadingProps;
